import React from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';

const ImportModal = ({
  show,
  onHide,
  importText,
  onImportTextChange,
  importType,
  onImportTypeChange,
  importSubtype,
  onImportSubtypeChange,
  creditCards,
  onImport,
  importLoading
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Importar Transações</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Tipo de Importação</Form.Label>
            <Form.Select
              value={importType}
              onChange={(e) => onImportTypeChange(e.target.value)}
              className="excel-form-control"
            >
              <option value="SPREADSHEET">Planilha</option>
              <option value="BANK">Banco</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              {importType === 'SPREADSHEET' ? 'Origem dos Dados' : 'Conta/Cartão'}
            </Form.Label>
            <Form.Select
              value={importSubtype}
              onChange={(e) => onImportSubtypeChange(e.target.value)}
              className="excel-form-control"
            >
              <option value="WITHOUT_CARD">Sem cartão</option>
              {creditCards.map(card => (
                <option key={card.id} value={card.id}>
                  {card.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>
              {importSubtype === 'WITHOUT_CARD' ? 
                (importType === 'SPREADSHEET' ? 'Cole aqui o texto da planilha' : 'Cole aqui o texto do banco') :
                `Cole aqui o texto do ${creditCards.find(c => c.id.toString() === importSubtype)?.name || 'cartão'}`
              }
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              value={importText}
              onChange={(e) => onImportTextChange(e.target.value)}
              placeholder={
                importSubtype === 'WITHOUT_CARD' ? 
                  (importType === 'SPREADSHEET' ? 
                    'Cole aqui o conteúdo da planilha...' : 
                    'Cole aqui o conteúdo do extrato do banco...') :
                  'Cole aqui o conteúdo do extrato do cartão...'
              }
              className="excel-form-control"
            />
            <Form.Text className="text-muted">
              {importSubtype === 'WITHOUT_CARD' ? (
                importType === 'SPREADSHEET' ?
                  'Cole o texto diretamente da planilha. Formato: Data | Categoria | Descrição | Conta | Valor | Saldo' :
                  'Formato de banco será definido em breve'
              ) : (
                <>
                  O texto deve estar no formato: Data | Categoria | Descrição | Data Uso | Valor
                  <br />
                  Exemplo: 06/01/23 | 49 | Mundial Calc-ct 03/03 | 26/10 | (83.33)
                </>
              )}
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          onClick={onImport}
          disabled={importLoading || (importSubtype !== 'WITHOUT_CARD' && !importSubtype) || !importText.trim()}
        >
          {importLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Importando...
            </>
          ) : (
            'Importar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImportModal; 